import { useEffect, useState } from "react"
import {
  isAfter, isBefore, isValid, minutesToMilliseconds, startOfDay,
} from "date-fns"
import { fromZonedTime, toZonedTime } from "date-fns-tz"
import { endOfStartDay } from "components/elements/Countdown"

export type EventPhase = "pre-event" | "day-of" | "post-event"

export const eventEnd = (start: Date, end: string | null, timezone: string) => (
  end ? new Date(end) : endOfStartDay(start, timezone)
)

// Day-of begins at midnight of the start day in the event's timezone, before doors open.
const startOfStartDay = (start: Date, timezone: string) => (
  fromZonedTime(startOfDay(toZonedTime(start, timezone)), timezone)
)

export const eventPhase = (
  start: string,
  end: string | null,
  timezone: string,
  now = Date.now(),
): EventPhase => {
  const startDate = new Date(start)
  if (!isValid(startDate) || isBefore(now, startOfStartDay(startDate, timezone))) {
    return "pre-event"
  }

  return isAfter(now, eventEnd(startDate, end, timezone)) ? "post-event" : "day-of"
}

export const useMinuteClock = () => {
  const [now, setNow] = useState(Date.now())

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), minutesToMilliseconds(1))

    return () => clearInterval(interval)
  }, [])

  return now
}
